import Grid from '@mui/material/Grid';
import ScMember from './scMember';
import BookedPooja from './bookedPooja';
import Reminders from './reminders';
import MyFavorateEvents from './events/myFavorateEvents';
import { Box, Typography } from '@mui/material';
import TimeToDonate from './TimeToDonate';
import styles from '../devotee.module.scss';
import DonationHistory from './donationHistory';
import UpcommingScMember from './upcommingScMember';
import { useEffect, useState } from 'react';
import { apiRequest } from '../../../infrastructure/backendService';
import apiPath from "../../../config/apiPaths.json";
import MPCDocument from './MPCDocument/MPCDocument';


export default function Dashboard(): React.ReactElement {
   const userName = sessionStorage.getItem('firstAndLastName');
   const [firstName, lastName] = userName ? userName.split(' ') : ['', ''];
   const capitalizedFirstName = firstName ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : '';
   const capitalizedLastName = lastName ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : '';

   const [minutesOfMeeting, setMinutesOfMeeting] = useState(false);
   const userRoleId = sessionStorage.getItem("userRoleId");
 
   useEffect(()=>{
      apiRequest({
         method: "GET",
         includeToken: true,
         endpoint: apiPath.administrativeMenus,
         params: {
           categoryId: userRoleId,
           page: 0,
           size: 20,
           direction: "asc"
         },
       })
      .then((res)=>{
         const isMinutesOfMeeting = res.data?.content?.some((each: any) => each?.key === "MINUTES_OF_MEETING")
         setMinutesOfMeeting(isMinutesOfMeeting);
      })
      .catch((err)=>{
         console.log(err)
      })
   },[userRoleId])

   return (
      <Box>
         <Typography className={styles.UsernameTitle}>Dashboard: {capitalizedFirstName} {capitalizedLastName}</Typography>
         <Grid container={true} spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} md={12} spacing={2}>
               <MyFavorateEvents />
            </Grid>
            <Grid item xs={12} md={12} spacing={2}>
               <Grid container={true} spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                  <Grid item xs={12} md={8} spacing={2}>
                     <BookedPooja />
                     <DonationHistory />
                     {minutesOfMeeting && <ScMember />}
                     {minutesOfMeeting && <MPCDocument/>}
                  </Grid>
                  <Grid item xs={12} md={4} spacing={2}>
                     <Reminders />
                     <TimeToDonate />
                     {minutesOfMeeting && <UpcommingScMember/>   }
                  </Grid>
               </Grid>
            </Grid>
        
            {/* <Grid item xs={12} md={8} spacing={2}>
        
            </Grid>
            <Grid item xs={12} md={4} spacing={2}>
        
            </Grid>
            <Grid item xs={12} sx={{marginTop:"15px"}}>
     
            </Grid> */}
         </Grid>

      </Box>
   );
}
